export default "//static.tradera.net/touchweb/static/output/images/app-store-badge-fr.8b729aa9.svg";